import { createContext, useContext } from "react";

import { Schemas } from "../../types";

export type BillingProfile = Schemas["BillingProfileCreate"];
export const initialBillingProfileValues: BillingProfile = {
  profile_name: "",
  customer_name: "",
  currency: "" as BillingProfile["currency"],
  invoicing_frequency: "" as BillingProfile["invoicing_frequency"],
  payer_option: "" as BillingProfile["payer_option"],
  collection_method: "" as BillingProfile["collection_method"],
  payment_method: "" as BillingProfile["payment_method"],
  sales_tax_number: null,
  purchase_order_number: null,
  address: {
    country: "",
    administrative_division_1: "",
    administrative_division_2: "",
    locality: "",
    address_line_1: "",
    postal_code: "",
    unit_number: "",
  },
  contact_first_name: "",
  contact_last_name: "",
  contact_email: "",
  contact_phone: null,
  cc_emails: [],
  customer_account: "",
  payment_profile_id: null,
  single_use_po: false,
};

interface CreateBillingProfileContextType {
  billingProfile: BillingProfile;
  setBillingProfile: (billingProfileData: BillingProfile) => void;
  currentStep: number;
  goToNextStep: () => void;
  goToPrevStep: () => void;
  formHasData: boolean;
  setFormHasData: (value: boolean) => void;
}

export const CreateBillingProfileContext =
  createContext<CreateBillingProfileContextType>({
    billingProfile: initialBillingProfileValues,
    setBillingProfile: (newState: BillingProfile) => newState,
    currentStep: 0,
    goToNextStep: () => {},
    goToPrevStep: () => {},
    formHasData: false,
    setFormHasData: (value: boolean) => value,
  });

export function useCreateBillingProfileContext() {
  return useContext(CreateBillingProfileContext);
}
